// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const Check = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M87.5 48c0 21.815-17.685 39.5-39.5 39.5S8.5 69.815 8.5 48 26.185 8.5 48 8.5 87.5 26.185 87.5 48ZM65.005 33.187 37.693 60.62 26.817 49.744l-3.505 3.625L37.694 67.75l30.938-30.937-3.626-3.626Z"
			fill="#fff"
		/>
	</svg>
);
export default Check;
